<template>
  <div class="app-contanier">
    <div class="top">
      <van-button class="cancel" @click="cancel" size="mini" type="default">取消交易</van-button>
    </div>
    <div class="pop">
      <div class="tit">请在下方区域扫描二维码</div>
      <div class="eg-bg">
        <van-image width="7.38rem" height="7.98rem" fit="contain" :src="require('@/assets/bg01.png')" />
        <div class="eg">
          <van-image width="2.8rem" height="2.8rem" fit="contain" :src="require('@/assets/code.png')" />
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { szfPay } from '@/api/home';



export default {
  name: 'onlinePay',
  data() {
    return {
      flag: true,
    }
  },


  created() {
    let that = this;
    let str = '';
    document.onkeydown = function (e) {
      var key = window.event.key;
      if (that.flag) {
        if (key === 'Enter') {
          that.pay(str)
          str = ''
        } else if (key.length == 1) {
          str = str + key;
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    pay(str) {
      if (str && this.flag) {
        this.flag = false;
        szfPay(str).then(res => { }).finally(error => {
          this.flag = true;
        });
      }
    }
  },
}
</script>

<style lang="less" scoped>
.app-contanier {
  padding: 23px 15px 75px;
}

.top {
  font-size: 17px;
  display: flex;
  justify-content: flex-end;

  .cancel {
    width: 90px;
    height: 30px;
    font-size: 12px;
  }
}

.pop {
  padding-top: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .tit {
    margin-bottom: 30px;
    font-size: 18px;
  }

  .eg-bg {
    // margin-top: 25px;
    // width: 100%;
    position: relative;

    .eg {
      position: absolute;
      bottom: 0px;
      right: 32px;

      animation: shaking 1.25s linear infinite;
      -webkit-animation: shaking 1.25s linear infinite;
    }


    .line {
      position: absolute;
      width: 111px;
      height: 3px;
      right: 30px;
      bottom: 75px;
      background-color: #FF0000;
    }
  }
}

@keyframes shaking {

  20% {
    bottom: 20px;
  }

  40% {
    bottom: 30px;
  }

  60% {
    bottom: 40px;
  }

  80% {
    bottom: 20px;
  }

  100% {
    bottom: 0;
  }
}
</style>
